import pairingErrors from '../../consts/device/pairingErrors';

export default class NoDeviceIsSelectedError extends Error {
    constructor(message = '', ...args) {
        super(message, ...args);
        this.message = 'No device was selected.';
        this.code = pairingErrors.ERROR_CONNECTION_NOT_FOUND.type;
    }
}
